<template>
    <div class="filter-section">
        <h2 class="filter-title">Search By</h2>
        <div class="d-flex gap-2">
            <button
                @click="setFilterTypeState('all')"
                class="btn-radio"
                :class="{ selected: filterType === 'all' }"
            >
                All
            </button>
            <button
                @click="setFilterTypeState('name')"
                class="btn-radio"
                :class="{ selected: filterType === 'name' }"
            >
                Name
            </button>
            <button
                @click="setFilterTypeState('chip')"
                class="btn-radio"
                :class="{ selected: filterType === 'chip' }"
            >
                Chip
            </button>
            <button
                @click="setFilterTypeState('tag')"
                class="btn-radio"
                :class="{ selected: filterType === 'tag' }"
            >
                Tag
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name: "TabPanelPatientFilter",
    computed: {
        filterType() {
            return this.$store.state.patient.filterType;
        }
    },
    methods: {
        setFilterTypeState(option) {
            this.$store.dispatch("patient/updateFilterType", option);
        }
    }
};
</script>

<style lang="scss" scoped>
$vet-text-subtle: #44546f;
$vet-text-subtlest: #626f86;
$vet-text-green: #527a22;
$vet-background-gray-subtlest: #f1f2f4;
$vet-background-green-subtlest: #e6eede;
$vet-border-focused: #388bff;

.filter-section {
    display: flex;
    flex-direction: column;
    padding: 12px 20px 8px;
}

.filter-title {
    color: $vet-text-subtle;
    padding-bottom: 4px;
    font-size: 13px;
}

.gap-2 {
    gap: 0.5rem; /* 8px */
}

.btn-radio {
    background-color: $vet-background-gray-subtlest;
    color: $vet-text-subtlest;
    padding: 4px 10px;
    border: 0;
    border-radius: 14px;
    font-weight: 500;
    font-size: 13px;

    &.selected {
        background: $vet-background-green-subtlest;
        color: $vet-text-green;
    }

    &:focus {
        outline: 2px solid $vet-text-green;
        outline-offset: 1px;
    }

    &:focus-visible {
        outline: 2px solid $vet-border-focused;
        outline-offset: 0;
    }
}

@media screen and (min-width: 1200px) {
    .filter-section {
        height: 100%;
        padding: 16px 24px 16px 20px;
    }
}
</style>
